import { isValidDate } from '@querodelivery/qd-date-helper';
import { formatDateToDDMMYYYY } from '@/Utils/FnUtils';

export const INVALID_DATE_LABEL = 'Data inválida';

export function isValidDateValue(date?: string) {
  if (!date) {
    return false;
  }

  return isValidDate(new Date(date));
}

export function formatApprovalDate(date?: string) {
  if (!isValidDateValue(date)) {
    return INVALID_DATE_LABEL;
  }

  const formattedDate = formatDateToDDMMYYYY(date);

  if (!formattedDate || formattedDate === 'Invalid Date') {
    return INVALID_DATE_LABEL;
  }

  return formattedDate;
}
